import { render, staticRenderFns } from "./SelectDemo.vue?vue&type=template&id=085027f6"
import script from "./SelectDemo.vue?vue&type=script&lang=js"
export * from "./SelectDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports